import React, { useState, useEffect } from 'react';

function BalanceStock() {
  const [data, setData] = useState({});
  const [instockData, setInStockData] = useState({});
  const [outstockData, setOutStockData] = useState({});
  const [balanceStockData, setBalanceStockData] = useState({});
  const [filteredData, setFilteredData] = useState([]);
  const udiseNumber = localStorage.getItem("udiseNumber");
  const [categoryFilter, setCategoryFilter] = useState('');
  const [inStockFilter, setInStockFilter] = useState('');
  const [outStockFilter, setOutStockFilter] = useState('');
  const [filterType, setFilterType] = useState('all');
  const [schoolName, setSchoolName] = useState("");
  const [taluka, setTaluka] = useState("");
  const [jilha, setJilha] = useState("");
  const [logoURL, setLogoURL] = useState(null);
  const [language, setLanguage] = useState(
    localStorage.getItem("language") || "English"
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const db = await openIndexedDB();
        const transaction = db.transaction(['inventory'], 'readonly');
        const objectStore = transaction.objectStore('inventory');
        const allRecords = objectStore.getAll();
  
        allRecords.onsuccess = (event) => {
          const data = event.target.result;
          const mergedData = {};
  
          data.forEach((record) => {
            if (record.key === 'instock') {
              mergedData.instock = record.value;
            } else if (record.key === 'outstock') {
              mergedData.outstock = record.value;
            }
          });
  
          setInStockData(mergedData.instock);
          setOutStockData(mergedData.outstock);
        };
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
  
    fetchData();
  }, [udiseNumber]);
  
  //   const fetchOutStockData = async () => {
  //     const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/inventory/outstock.json`;
  //     try {
  //       const response = await fetch(url, {
  //         method: 'GET',
  //       });
  //       const data = await response.json();
  //       setOutStockData(data);
  //     } catch (error) {
  //       console.error('Error fetching out-stock data:', error);
  //     }
  //   };
  
  //   fetchData();
  //   fetchOutStockData();
  // }, [udiseNumber]);


  
  const openIndexedDB = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('SchoolManagementDB', 1);
      
      request.onerror = (event) => {
        console.error('Database error:', event.target.error);
        reject('Error opening IndexedDB');
      };
      
      request.onsuccess = (event) => {
        resolve(event.target.result);
      };
      
      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('inventory')) {
          db.createObjectStore('inventory', { keyPath: 'id' });
        }
      };
    });
  };


  useEffect(() => {
    const calculateBalanceStock = () => {
      if (!instockData || typeof instockData !== 'object') {
        setBalanceStockData({});
        return;
      }

      const balanceStock = {};
      Object.keys(instockData).forEach((key) => {
        if (instockData[key] && instockData[key].Material) {
          const material = instockData[key].Material;
          const category = instockData[key].Heading;
          const inStockQuantity = Object.values(instockData[key]).reduce((acc, item) => {
            if (item.Quantity) {
              return acc + parseInt(item.Quantity);
            }
            return acc;
          }, 0);

          const outStockQuantity = outstockData ? Object.values(outstockData).reduce((acc, item) => {
            if (item.Material === material && item.Heading === category) {
              return acc + parseInt(item.Quantity);
            }
            return acc;
          }, 0) : 0;

          const remainingStock = inStockQuantity - outStockQuantity;

          balanceStock[material] = {
            Category: category,
            Material: material,
            InStock: inStockQuantity,
            OutStock: outStockQuantity,
            RemainingStock: remainingStock,
          };
        }
      });

      setBalanceStockData(balanceStock);
    };

    calculateBalanceStock();
  }, [instockData, outstockData]);

  useEffect(() => {
    const filterData = () => {
      if (!balanceStockData || typeof balanceStockData !== 'object') {
        setFilteredData({});
        return;
      }

      const filtered = Object.values(balanceStockData).filter((item) => {
        const categoryMatch = categoryFilter === '' || item.Category === categoryFilter;
        const inStockMatch = inStockFilter === '' || item.InStock === parseInt(inStockFilter);
        const outStockMatch = outStockFilter === '' || item.OutStock === parseInt(outStockFilter);
        return categoryMatch && inStockMatch && outStockMatch;
      });
console.log("filtered",filtered);

      setFilteredData(filtered);
    };

    filterData();
  }, [balanceStockData, categoryFilter, inStockFilter, outStockFilter]);

  const handlePrint = () => {
    const printContent = document.querySelector('.balance-stock-table');

    if (printContent) {
      const cloneContent = printContent.cloneNode(true);

      // Modify the cloned content as needed
      const otherDetails = cloneContent.querySelectorAll('p'); 
      otherDetails.forEach((p, index) => {
        if (index !== 0) { 
          p.style.fontWeight = 'normal'; 
        }
      });

      const printWindow = window.open('', '', 'height=800,width=600');
      printWindow.document.write(`
        <html>
          <head>
            <style>
              @page {
                size: A4 Potrait;
                margin: 5mm;
                padding: 15px;
                border: 1px solid black;
              }
              body {
                font-family: Arial, sans-serif;
                margin: 0;
                padding: 0;
              }
              table {
                border-collapse: collapse;
                width: 100%;
                font-size: 16px;
              }
              th, td {
                border: 1px solid black;
                text-align: center;
                padding: 5px;
              }
              td {
                font-size: 16px;
              }
              th {
                background-color:  rgb(166 214 245);
              }
              .print-button {
                display: none;
              }
              .school-header-container {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;
              }
              .school-header2 {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                flex: 0 0 auto; /* Prevent this section from growing */
                margin-right: 10px;
              }
              .school-header2 img {
                max-height: 70px;
              }
              .school-header {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                text-align: center; margin-left:-70px;
                flex: 1 1 auto; /* This makes the school header take available space */
              }
              .school-header h1 {
                font-size: 28px;
                margin: 5px 0;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .school-header .report-title {
                font-size: 20px;
                margin: 5px auto;
                font-weight: bold;
                border: 1px solid black;
                width: 230px;
                padding: 5px;
                text-align: center;
                border-radius: 10px;
                background-color: black;
                color: white;
              }
              .school-header .report-tit {
                font-size: 16px;
                margin: 5px auto;
                font-weight: bold;
                text-align: center;
              }
            </style>
          </head>
          <body>
            <div class="school-header-container">
              <div class="school-header2">
                ${logoURL ? `<img src="${logoURL}" alt="School Logo" onload="window.print()">` : '<div></div>'}
              </div>
              <div class="school-header">
                <div style="margin-left: 15px;">
                  <h1>${schoolName}</h1>
                  <div class="report-tit">
                    ${language === 'English' ? 'Taluka' : 'तालुका'} ${taluka}, ${language === 'English' ? 'District' : 'जिल्हा'} : ${jilha}
                  </div>
                  <div class="report-title">
                    ${language === "English" ?  "Current Stock Report" : "सध्याचा साठा अहवाल"}
                  </div>
                </div>
              </div>
            </div>
            <style>
              .styled-table {
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
              }
            </style>
            ${cloneContent.outerHTML}
          </body>
        </html>
`);
      printWindow.document.close(); 

      printWindow.focus(); // Focus the new window
      printWindow.print(); // Trigger print
      printWindow.close(); // Close the print window after printing
    } else {
      console.error('Print content not found');
    }
  };

  const fetchSchoolName = async () => {
    if (udiseNumber) {
      try {
        const db = await openIndexedDB();
        const transaction = db.transaction(['schoolData'], 'readonly');
        const objectStore = transaction.objectStore('schoolData');
        const request = objectStore.get(udiseNumber);

        request.onsuccess = (event) => {
          const schoolData = event.target.result;
          if (schoolData) {
            if (schoolData.schoolName) {
              setSchoolName(schoolData.schoolName);
            }
            if (schoolData.taluka) {
              setTaluka(schoolData.taluka);
            }
            if (schoolData.jilha) {
              setJilha(schoolData.jilha);
            }
            if (schoolData.schoolLogo) {
              setLogoURL(schoolData.schoolLogo);
            }
          }
        };

        request.onerror = (event) => {
          console.error("Error fetching school data:", event.target.error);
        };
      } catch (error) {
        console.error('Error fetching school data:', error);
      }
    }
  };

  useEffect(() => {
  fetchSchoolName();
}, [udiseNumber]);



  return (
    <div className='main-content-of-page' style={{ padding: '20px' }}>
      <div style={{ border: '1px solid #ccc', width: '80%', margin: 'auto', marginTop: '10px', padding: '25px 30px ', borderRadius:'5px', boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)' }}>
        <h3 style={{textAlign:'center',color:'#03365e',fontWeight:'bold', marginBottom:'15px'}}>{language === "English" ?  "Current Stock" : "सध्याचा साठा"}</h3>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <div style={{ marginRight: '15px', width: '20%' }}>
            <label style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px', width: '100%' }}>{language === "English" ? "Category:" : "कॅटेगरी:"}</label>
            <select
              value={categoryFilter}
              onChange={(event) => setCategoryFilter(event.target.value)}
              style={{ padding: '6px', fontSize: '14px', border: '1px solid #ccc', borderRadius: '5px', width: '100%' }}
            >
              <option value="">All</option>
              {Object.values(balanceStockData).map((item, index) => (
                <option key={index} value={item.Category}>{item.Category}</option>
              ))}
            </select>
          </div>

          <div style={{ marginRight: '15px', width: '20%' }}>
            <label style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px', width: '100%' }}>Filter By:</label>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <input
                  type='radio'
                  name='filterType'
                  value='all'
                  checked={filterType === 'all'}
                  onChange={(event) => setFilterType(event.target.value)}
                />
                <label style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px', width: '100%' }}>All</label>
              </div>
              <div>
                <input
                  type='radio'
                  name='filterType'
                  value='instock'
                  checked={filterType === 'instock'}
                  onChange={(event) => setFilterType(event.target.value)}
                />
                <label style ={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px', width: '100%' }}>{language === "English" ? "Stock Inword" : "आवक साठा"} </label>
              </div>
              <div>
                <input
                  type='radio'
                  name='filterType'
                  value='outstock'
                  checked={filterType === 'outstock'}
                  onChange={(event) => setFilterType(event.target.value)}
                />
                <label style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px', width: '100%' }}>{language === "English" ? "Stock Outward" : "जावक साठा"}</label>
              </div>
            </div>
          </div>
        </div>
        <table className="balance-stock-table" style={{
          width: '100%',
          borderCollapse: 'collapse',
          marginBottom: '30px',
          fontFamily: 'Arial, sans-serif',
          border: '1px solid black',
          borderRadius: '10px',
          boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
        }}>
<thead>
  <tr>
    <th style={{fontWeight:'bold',  border: '1px solid black', padding: '6px 5px' , textAlign: "center" }}>{language === "English" ? "Category" : "कॅटेगरी"}</th>
    <th style={{fontWeight:'bold',  border: '1px solid black', padding: '6px 5px' , textAlign: "center" }}>{language === "English" ? "Material" : "साहित्य"}</th>
    {(filterType === 'instock' || filterType === 'all') && (
      <th style={{fontWeight:'bold',  border: '1px solid black', padding: '6px 5px' , textAlign: "center" }}>{language === "English" ? "Stock Inword" : "आवक साठा"} </th>
    )}
    {(filterType === 'outstock' || filterType === 'all') && (
      <th style={{fontWeight:'bold',  border: '1px solid black', padding: '6px 5px' , textAlign: "center" }}>{language === "English" ? "Stock Outward" : "जावक साठा"}</th>
    )}
    <th style={{fontWeight:'bold',  border: '1px solid black', padding: '6px' , textAlign: "center" }}>{language === "English" ? "Remaining Stock" : "शिल्लक साठा"} </th>
  </tr>
</thead>
<tbody>
  {Array.isArray(filteredData) && filteredData.map((item, index) => (
    <tr key={index}>
      <td style={{ border: '1px solid black', padding: '6px' }}>{item.Category}</td>
      <td style={{ border: '1px solid black', padding: '6px' }}>{item.Material}</td>
      {(filterType === 'instock' || filterType === 'all') && (
        <td style={{ border: '1px solid black', padding: '6px' }}>{item.InStock}</td>
      )}
      {(filterType === 'outstock' || filterType === 'all') && (
        <td style={{ border: '1px solid black', padding: '6px' }}>{item.OutStock}</td>
      )}
      <td style={{ border: '1px solid black', padding: '6px' }}>{item.RemainingStock}</td>
    </tr>
  ))}
</tbody>
        </table>
        <div style={{ textAlign: 'center' }}>
          <button type="button" onClick={handlePrint} style={{
            marginTop: '-15px',
            padding: '8px 16px',
            fontSize: '14px',
            backgroundColor: '#d4a017',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            marginLeft: '20px',
            right: '0',
            float: 'right'
          }}>
            {language === "English" ? "Print" : "प्रिंट "}
          </button>
        </div>
      </div>
    </div>
  );
}

export default BalanceStock;